import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { createAction } from "typesafe-actions";
import NotificationSettingResource from "@ane/exp-data/lib/resources/NotificationSettingResource";
const defaultReducerState = getDefaultAsyncWrapperObj();
const actionPrefix = "PutNotificationSetting";
const putNotificationSettingDetailEpicReducerArg = {
  actionPrefix,
  reduxKeyNested: () => ["value"],
  loadResource: (request) => NotificationSettingResource.putNotificationSetting(request.workspaceId, request.id, request.notificationSubscriptionConfig),
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const putNotificationSettingEpicReducer = loadResourcesUtils(putNotificationSettingDetailEpicReducerArg);
const putNotificationSettingStateDefault = {
  value: getDefaultAsyncWrapperObj()
};
const PutNotificationSettingReducer = (state = putNotificationSettingStateDefault, action) => {
  state = putNotificationSettingEpicReducer.reduxChange(state, action);
  return state;
};
const resetPutResult = createAction(`${actionPrefix}/RESET`);
export {
  PutNotificationSettingReducer,
  PutNotificationSettingReducer as default,
  defaultReducerState,
  putNotificationSettingEpicReducer,
  putNotificationSettingStateDefault,
  resetPutResult
};
//# sourceMappingURL=PutNotificationSetting.ducks.js.map
